import { HttpEvent, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { $app } from '../../../../app.service'
import { WbsRisk } from '../../../../features/feature-wbs/models/interfaces/wbs-risk.interface'
import { AppBasicService } from '../../../services/app-basic.service'
import { WbsDeliverableListItem } from '../../../../features/feature-wbs/models/interfaces/wbs-deliverable.interface'
import { WbsMilestoneListItem } from '../../../../features/feature-wbs/models/interfaces/wbs-milestone.interface'
import { WbsWorkpackageListItem } from '../../../../features/feature-wbs/models/interfaces/wbs-workpackage.interface'

@Injectable()
export class WbsService extends AppBasicService {
   exportGantt(): Observable<HttpEvent<Blob>> {
      if (this.console) console.log(this.logPrefix, 'exportGantt')

      const projectId = $app.getCurrentProjectId()

      return this.exportFile(`${this._configService.apiUrl}/workplans/gantt/${projectId}/exportExcelFile`)
   }

   getWorkpackageList(): Observable<WbsWorkpackageListItem[]> {
      if (this.console) console.log(this.logPrefix, 'getWorkpackageList')

      const projectId = $app.getCurrentProjectId()

      return this.http.get<WbsWorkpackageListItem[]>(`${this._configService.apiUrl}/workplans/projects/${projectId}/workpackages`)
   }

   exportWorkpackageList(): Observable<HttpEvent<Blob>> {
      if (this.console) console.log(this.logPrefix, 'exportWorkpackageList')

      const projectId = $app.getCurrentProjectId()

      return this.exportFile(`${this._configService.apiUrl}/workplans/projects/${projectId}/workpackages/exportMsWordFile`)
   }

   getDeliverableList(): Observable<WbsDeliverableListItem[]> {
      if (this.console) console.log(this.logPrefix, 'getDeliverableList')

      const projectId = $app.getCurrentProjectId()

      return this.http.get<WbsDeliverableListItem[]>(`${this._configService.apiUrl}/workplans/projects/${projectId}/deliverables`)
   }

   exportDeliverableList(includeDescription: boolean): Observable<HttpEvent<Blob>> {
      if (this.console) console.log(this.logPrefix, 'exportDeliverableList')

      const projectId = $app.getCurrentProjectId()

      return this.exportFile(
         `${this._configService.apiUrl}/workplans/projects/${projectId}/deliverables/exportMsWordFile${includeDescription ? '?includeDescriptions=true' : ''}`
      )
   }

   getMilestoneList(): Observable<WbsMilestoneListItem[]> {
      if (this.console) console.log(this.logPrefix, 'getMilestoneList')

      const projectId = $app.getCurrentProjectId()

      return this.http.get<WbsMilestoneListItem[]>(`${this._configService.apiUrl}/workplans/projects/${projectId}/milestones`)
   }

   exportMilestoneList(): Observable<HttpEvent<Blob>> {
      if (this.console) console.log(this.logPrefix, 'exportMilestoneList')

      const projectId = $app.getCurrentProjectId()

      return this.exportFile(`${this._configService.apiUrl}/workplans/projects/${projectId}/milestones/exportMsWordFile`)
   }

   getRiskList(): Observable<WbsRisk[]> {
      if (this.console) console.log(this.logPrefix, 'getRiskList')

      const projectId = $app.getCurrentProjectId()

      return this.http.get<WbsRisk[]>(`${this._configService.apiUrl}/workplans/projects/${projectId}/risks`)
   }

   exportRiskList(): Observable<HttpEvent<Blob>> {
      if (this.console) console.log(this.logPrefix, 'exportRiskList')

      const projectId = $app.getCurrentProjectId()

      return this.exportFile(`${this._configService.apiUrl}/workplans/projects/${projectId}/risks/exportMsWordFile`)
   }

   getRiskById(id: number): Observable<WbsRisk> {
      return this.http.get<WbsRisk>(`${this._configService.apiUrl}/workplans/risks/${id}`)
   }

   insertRisk(data: Partial<WbsRisk>): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      const params = { ...data, projectId: Number(projectId) }

      return this.http.put<void>(`${this._configService.apiUrl}/workplans/risks`, params)
   }

   updateRisk(id: number, data: Partial<WbsRisk>): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      const params = { ...data, id, projectId }

      return this.http.patch<void>(`${this._configService.apiUrl}/workplans/risks`, params)
   }

   deleteRisk(id: number): Observable<void> {
      return this.http.delete<void>(`${this._configService.apiUrl}/workplans/risks/${id}`)
   }

   copyRisk(id: number): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      const params = {
         riskId: id,
         projectId: projectId
      }

      return this.http.post<void>(`${this._configService.apiUrl}/workplans/risks:copy`, params)
   }

   changeRiskOrder(data: number[]): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      const params = { sortedRisksId: data }

      return this.http.post<void>(`${this._configService.apiUrl}/workplans/projects/${projectId}/risks:sort`, params)
   }

   private exportFile(url: string): Observable<HttpEvent<Blob>> {
      const httpOptions = {
         headers: new HttpHeaders({
            'Content-Type': 'application/json'
         }),
         reportProgress: true,
         observe: 'events' as 'body',
         responseType: 'blob' as 'json'
      }

      return this.http.get(url, httpOptions) as Observable<HttpEvent<Blob>>
   }
}
